export const DeleteRuleIcon = () => {
  return (
    <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 4.29541H14" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.875 7.54834V12.4233" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M9.12744 7.54834V12.4233"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.81494 4.29541L2.62744 14.0454C2.62744 14.4764 2.79865 14.8897 3.10339 15.1945C3.40814 15.4992 3.82146 15.6704 4.25244 15.6704H10.7524C11.1834 15.6704 11.5967 15.4992 11.9015 15.1945C12.2062 14.8897 12.3774 14.4764 12.3774 14.0454L13.1899 4.29541"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.06396 4.29688V1.85938C5.06396 1.64389 5.14957 1.43722 5.30194 1.28485C5.45431 1.13248 5.66098 1.04688 5.87646 1.04688H9.12646C9.34195 1.04688 9.54862 1.13248 9.70099 1.28485C9.85336 1.43722 9.93896 1.64389 9.93896 1.85938V4.29688"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
